import { render, staticRenderFns } from "./tarinActivity.vue?vue&type=template&id=2625033f"
import script from "./tarinActivity.vue?vue&type=script&lang=js"
export * from "./tarinActivity.vue?vue&type=script&lang=js"
import style0 from "./tarinActivity.vue?vue&type=style&index=0&id=2625033f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports